/** Transporter / truck-owner display name and slip helpers. */

import { normalizeVehicleNumber } from "./vehicleNumber";

/** Ledger identity — owner only (never append vehicle). */
export function formatTransporterLedgerName(ownerName) {
  let owner = String(ownerName || "").trim().replace(/\s+/g, " ");
  for (const sep of [" - ", " · ", " – "]) {
    if (!owner.includes(sep)) continue;
    const idx = owner.lastIndexOf(sep);
    const left = owner.slice(0, idx).trim();
    const right = owner.slice(idx + sep.length).replace(/\s+/g, "");
    if (/^[A-Za-z]{2}\d{1,2}[A-Za-z]{0,3}\d{1,4}$/.test(right)) {
      return left;
    }
  }
  return owner;
}

/**
 * Slip / UI label. Vehicle is trip context only; does not create a party per truck.
 */
export function formatTransporterDisplayName(ownerName, vehicleNumber) {
  const owner = formatTransporterLedgerName(ownerName);
  const vehicle = normalizeVehicleNumber(vehicleNumber);
  if (owner && vehicle) return `${owner} · ${vehicle}`;
  return owner || vehicle || "";
}

export const TRANSPORTER_BANK_SLIP_KEYS = ["bank_name", "bank_account_no", "bank_ifsc", "pan_no"];

export function bankFieldsFromParty(party) {
  if (!party) return {};
  const pan = party.pan || party.pan_no || "";
  return {
    bank_name: party.bank_name || "",
    bank_account_no: party.bank_account_no || "",
    bank_ifsc: party.bank_ifsc || "",
    pan_no: pan,
    truck_owner_pan: pan,
  };
}
